import { render, staticRenderFns } from "./3c_doc.vue?vue&type=template&id=8c599d3a&scoped=true"
import script from "./3c_doc.vue?vue&type=script&lang=js"
export * from "./3c_doc.vue?vue&type=script&lang=js"
import style0 from "./3c_doc.vue?vue&type=style&index=0&id=8c599d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c599d3a",
  null
  
)

export default component.exports